import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { getDiscountConfiguration } from '@vy/services';
import type { Currency, PlanBillingData, PlanInputFormFixedProduct } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import React, { Fragment } from 'react';
import { DiscountTableRow } from './DiscountTableRow';
import { FixedProductSectionTableRow } from './FixedProductSectionTableRow';

type FixedProductsSectionProps = {
  fixedProducts: PlanInputFormFixedProduct[];
  billingData: Partial<PlanBillingData>;
  currency: Currency;
};

export const FixedProductsSection: React.FC<FixedProductsSectionProps> = ({
  fixedProducts,
  billingData,
  currency,
}) => {
  return (
    <section>
      <Typography
        variant="overline"
        sx={{
          color: "text.secondary",
          fontWeight: 300
        }}>
        Service Fees
      </Typography>
      <TableContainer>
        <Table
          style={{
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell className="p-0 pb-1.5 text-[10px] font-light leading-3 text-[#576063]">
                Name
              </TableCell>
              <TableCell
                className="p-0 pb-1.5 text-[10px] font-light leading-3 text-[#576063]"
                align="center"
              >
                Quantity
              </TableCell>
              <TableCell
                className="p-0 pb-1.5 text-[10px] font-light leading-3 text-[#576063]"
                align="center"
              >
                Price Per Unit
              </TableCell>
              <TableCell className="p-0 pb-1.5 text-[10px] font-light leading-3 text-[#576063]" align="right">
                Amount
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {fixedProducts.map((product, index) => {
              const discountConfiguration = getDiscountConfiguration(product);
              const showDiscountAsLineItem =
                isNotNullOrUndefined(discountConfiguration?.amountToDeduct) ||
                isNotNullOrUndefined(discountConfiguration?.name) ||
                isNotNullOrUndefined(discountConfiguration?.type);

              return (
                <Fragment key={index}>
                  <FixedProductSectionTableRow
                    key={crypto.randomUUID()}
                    fixedProduct={product}
                    billingData={billingData}
                    currency={currency}
                  />

                  {showDiscountAsLineItem && (
                    <DiscountTableRow
                      key={crypto.randomUUID()}
                      discountConfiguration={discountConfiguration}
                      currency={currency}
                    />
                  )}
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </section>
  );
};
